/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OralExamSupervisorVisitResponseRung =
  (typeof OralExamSupervisorVisitResponseRung)[keyof typeof OralExamSupervisorVisitResponseRung];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamSupervisorVisitResponseRung = {
  observing: 'observing',
  visible: 'visible',
  speaking: 'speaking',
} as const;
